function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i]}return arr2}else{return Array.from(arr)}}export var spliced=function spliced(array,i){var array_=[].concat(_toConsumableArray(array));array_.splice(i,1);return array_};export var debug=function debug(){var _console;if(!window.localStorage['react-easy-print-debug'])return;(_console=console).log.apply(_console,arguments);// eslint-disable-line
};
//# sourceMappingURL=common.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-easy-print/lib/es/common.js
// module id = 269
// module chunks = 0